var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: {
      'toggle-menu-root': _vm.menu
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": _vm.menu
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('div', _vm._g(_vm._b({
          staticClass: "lidar-toggle",
          class: {
            'lidar-toggle--disabled': !_vm.hasSession || _vm.loadingPreference,
            'lidar-toggle--on': _vm.useLidar,
            'lidar-toggle--menu': _vm.menu
          },
          attrs: {
            "role": "switch",
            "tabindex": "0",
            "aria-checked": String(_vm.useLidar)
          },
          on: {
            "click": _vm.requestToggle,
            "keydown": [function ($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              $event.preventDefault();
              return _vm.requestToggle.apply(null, arguments);
            }, function ($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
              $event.preventDefault();
              return _vm.requestToggle.apply(null, arguments);
            }]
          }
        }, 'div', attrs, false), on), [_c('v-icon', {
          staticClass: "lidar-toggle__icon",
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-cube-scan")]), _c('span', {
          staticClass: "lidar-toggle__label"
        }, [_vm._v("Use LiDAR")]), _c('v-switch', {
          staticClass: "lidar-toggle__switch",
          attrs: {
            "input-value": _vm.useLidar,
            "color": "blue lighten-1",
            "dense": "",
            "inset": "",
            "hide-details": "",
            "readonly": "",
            "aria-label": _vm.ariaLabel,
            "disabled": !_vm.hasSession || _vm.loadingPreference || _vm.saving
          },
          nativeOn: {
            "click": function ($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return _vm.requestToggle.apply(null, arguments);
            }
          }
        })], 1)];
      }
    }])
  }, [_c('span', [_vm._v(_vm._s(_vm.tooltipText))])]), _c('v-dialog', {
    attrs: {
      "content-class": "app-dialog lidar-dialog",
      "attach": ".v-application",
      "max-width": "520",
      "retain-focus": false
    },
    on: {
      "input": _vm.onConfirmDialogInput,
      "click:outside": _vm.cancelLidar
    },
    model: {
      value: _vm.confirmDialog,
      callback: function ($$v) {
        _vm.confirmDialog = $$v;
      },
      expression: "confirmDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "lidar-dialog__title"
  }, [_vm._v(" Use LiDAR during recording? ")]), _c('v-card-text', [_c('p', {
    staticClass: "mb-2"
  }, [_vm._v(" Only iPhones with a LiDAR sensor will capture depth data. Any other phones will record normal RGB video instead. ")]), _c('p', {
    staticClass: "mb-0 lidar-dialog__recommendation"
  }, [_vm._v(" LiDAR is available on the iPhone 12 Pro / 12 Pro Max and all later Pro and Pro Max models. ")])]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.cancelLidar
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": "",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.confirmLidar
    }
  }, [_vm.saving ? _c('v-progress-circular', {
    staticClass: "mr-2",
    attrs: {
      "indeterminate": "",
      "color": "grey",
      "size": "14",
      "width": "2"
    }
  }) : _vm._e(), _vm._v(" Use LiDAR ")], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }